import { Skeleton } from '@mui/material';
import clsx from 'clsx';

import { SwitchInterface } from '@types';
import Tooltip from '@components/tooltip/Tooltip';

const Switch: React.FC<SwitchInterface> = ({
  handleClick,
  value = true,
  disabled = false,
  className,
  label,
  loading,
  hasAccess = true,
  labelClassName,
  testId,
  tooltipText,
  ...props
}) => {
  const toggleSwitch = () => {
    if (!disabled && !loading) {
      handleClick(!value);
    }
  };

  const containerClassNames = 'flex h-6 items-center justify-center';
  const buttonClassNames = clsx(
    'flex h-4.5 w-8  items-center rounded-3xl p-1',
    disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
  );

  const buttonVariantStyles = value
    ? 'bg-primary20 border border-primary'
    : 'border border-grey80 bg-white';

  const switchVariantStyles = value
    ? 'translate-x-2.5 bg-primary'
    : '-translate-x-1 bg-white border border-grey80';

  const switchClassNames = 'h-4 w-4 rounded-3xl duration-300 ease-in-out';

  return loading ? (
    <Skeleton animation="wave" width={86} />
  ) : (
    <div className={clsx(containerClassNames, className)}>
      <span
        className={clsx(
          `mr-2 text-base ${labelClassName}`,
          value ? 'text-primary' : 'text-grey80'
        )}
      >
        {label}
      </span>
      {hasAccess && (
        <button
          type="button"
          className={clsx(buttonClassNames, buttonVariantStyles)}
          onClick={toggleSwitch}
          data-tooltip-id={`${testId}-switch`}
          data-testid={`${testId}-switch-button`}
          {...props}
        >
          <div className={clsx(switchClassNames, switchVariantStyles)} />
        </button>
      )}
      <Tooltip
        id={`${testId}-switch`}
        type="text"
        tooltipText={tooltipText}
        className="max-w-120 leading-5"
        place="top-start"
      />
    </div>
  );
};

export default Switch;
